/* eslint-disable no-case-declarations */
import { Reducer } from 'redux';
// import _ from 'lodash';

import { Action, ActionType } from '../actionTypes/invoiceActionTypes';
import { IInvoiceReport1, IInvoiceReport2, IInvoiceFCReport1, IInvoiceFCReport2, IInvoice as Invoice } from '../../models/invoice';

export interface IInvoicesState {
    invoices: Invoice[];
    invoiceReport1: IInvoiceReport1;
    invoiceReports2: IInvoiceReport2[];
    invoiceFCReport1: IInvoiceFCReport1;
    invoiceFCReports2: IInvoiceFCReport2[];
    loading: boolean;
    error: string | null,
}
const initialState = {
    invoices: [],
    invoiceReport1: {
        allReceived: 0,
        cp_pp_r: 0, 
        confirmedAmount: 0, 
        pp_pp_r: 0, 
        cvat_r: 0,
        confirmedInvoiceAmounts: 0,
        sentInvoiceAmounts: 0,
        aci_g_r: 0,
        icc_g_r: 0,
        aca_g_r: 0,
        acc_g_r: 0,
        ew_g_r: 0,
        ewcc_g_r: 0,    
        receivePercent: 0,
    },
    invoiceReports2: [],
    invoiceFCReport1: {
        allFCReceived: 0,
        cp_pp_fc: 0, 
        confirmedFCAmount: 0, 
        pp_pp_fc: 0, 
        cvat_fc: 0,
        confirmedInvoiceFCAmounts: 0,
        sentInvoiceFCAmounts: 0,
        aci_g_fc: 0,
        icc_g_fc: 0,
        aca_g_fc: 0,
        acc_g_fc: 0,
        ew_g_fc: 0,
        ewcc_g_fc: 0,    
        receiveFCPercent: 0,
    },
    invoiceFCReports2: [],
    loading: false,
    error: null,   
};
export const InvoiceReducer: Reducer<IInvoicesState, Action> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case ActionType.FETCH_INVOICES:
        case ActionType.FETCH_INVOICEREPORT1:
        case ActionType.FETCH_INVOICEREPORT2:
        case ActionType.FETCH_INVOICEFCREPORT1:
        case ActionType.FETCH_INVOICEFCREPORT2:
        case ActionType.ADD_INVOICE:
        case ActionType.EDIT_INVOICE:
        case ActionType.DELETE_INVOICE:
            return { ...state, loading: true };

        case ActionType.FETCH_INVOICES_FAIL:
        case ActionType.FETCH_INVOICEREPORT1_FAIL:
        case ActionType.FETCH_INVOICEREPORT2_FAIL:
        case ActionType.FETCH_INVOICEFCREPORT1_FAIL:
        case ActionType.FETCH_INVOICEFCREPORT2_FAIL:
        case ActionType.ADD_INVOICE_FAIL:
        case ActionType.EDIT_INVOICE_FAIL:
        case ActionType.DELETE_INVOICE_FAIL:
            return { 
                ...state, 
                loading: false,
                error: action.payload
            };

        case ActionType.ADD_INVOICE_SUCCESS:
            // console.log("action.payload: ", action.payload)
            return {
                ...state,
                invoices: [ ...state.invoices, action.payload ],
                loading: false
            };

        case ActionType.FETCH_INVOICES_SUCCESS:
            return {
                ...state,
                invoices: action.payload.data,
                loading: false
            };

        case ActionType.FETCH_INVOICEREPORT1_SUCCESS:
            return {
                ...state,
                invoiceReport1: action.payload.data,
                loading: false
            };

        case ActionType.FETCH_INVOICEREPORT2_SUCCESS:
            return {
                ...state,
                invoiceReports2: action.payload.data,
                loading: false
            };            

        case ActionType.FETCH_INVOICEFCREPORT1_SUCCESS:
            return {
                ...state,
                invoiceFCReport1: action.payload.data,
                loading: false
            };

        case ActionType.FETCH_INVOICEFCREPORT2_SUCCESS:
            return {
                ...state,
                invoiceFCReports2: action.payload.data,
                loading: false
            };            

        case ActionType.EDIT_INVOICE_SUCCESS:
            const invoice: Invoice = action.payload
            const index = state.invoices.findIndex(itm => 
                Number(itm.invoiceid) === Number(invoice.invoiceid)
            )
            const invoicesPart1 = state.invoices.slice(0, index)
            const invoicesPart2 = state.invoices.slice(index + 1)
            return {
                ...state,
                invoices: [ ...invoicesPart1, invoice, ...invoicesPart2 ],
                loading: false
            };
        case ActionType.DELETE_INVOICE_SUCCESS:
            return {
                ...state,
                invoices: state.invoices.filter(invoice => invoice.invoiceid !== action.payload),
            };

        default:
            return state;
    }
};
